import { 
  INIT_APP3,
  INIT_APP3_SUCCESS,
  LOAD_CONFIGURATION3_SUCCESS,
  LOAD_HTMLTEMPLATES3_SUCCESS,
  RECONNECT3_SUCCESS,
  ERROR,
  WARNING,
  CONFIRM_WARNING
} from "../constants";

import produce from "immer"


const initialState = {
    initApp: false,
    configuration: null,
    error: null,
    warning:null,
    orgName: null
};

const app3Reducer = produce((draft, action) => {

    // console.log(`%c SAGA-REDUCER called with action: ${action.type} `,'background: #222; color: #bada55');

    switch (action.type) {

      case INIT_APP3: {
        draft.initApp = false;
        break;
      }
      case LOAD_HTMLTEMPLATES3_SUCCESS: {
        draft.htmlTemplates = action.templates;
        break;

    }
      case RECONNECT3_SUCCESS:
      case INIT_APP3_SUCCESS: {
        draft.initApp = true;
        draft.orgName= action.orgName;
        break;
        
      }
      case LOAD_CONFIGURATION3_SUCCESS: {
        draft.configuration = action.configuration;
        break;
      } 
      case ERROR: {
        draft.error = action.error
        break;
      }
      case WARNING: {
        draft.warning = action.warning
        break;
      }
      case CONFIRM_WARNING: {
        delete draft.warning;
        break;
      }
      default: 
        break;
    }
},initialState)

export default app3Reducer;

/* Getters */

export const getInitApp3Success = state => {
  return state.initApp;
};


export const getConfiguration3 = state => {
  return state.configuration;
};

export const getError = state => {
  return state.error;
};

export const getWarning = state => {
  return state.warning;
};


export const getHTMLTemplates3 = state => {
  return state.htmlTemplates;
};